module.exports = __webpack_public_path__ + "img/avatar-03-140x140.14860c97.png";